import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import { UserModel, users } from './modules/users'
import { EventModel, events } from './modules/events'
import Api from './api'

Vue.use(Vuex)

let initialModules = {
  users: {
    model: UserModel,
    store: users
  },
  events: {
    model: EventModel,
    store: events
  }
}

Object.keys(initialModules).map(key => {
  initialModules[key].initalState = {}
  if (initialModules[key].store.state) {
    Object.keys(initialModules[key].store.state).map(stateKey => {
      if (typeof initialModules[key].store.state[stateKey] === 'object' && initialModules[key].store.state[stateKey] !== null) {
        initialModules[key].initalState[stateKey] = {
          ...initialModules[key].store.state[stateKey]
        }
      } else {
        initialModules[key].initalState[stateKey] = initialModules[key].store.state[stateKey]
      }
    })
  }
})

const database = new VuexORM.Database()

Object.keys(initialModules).forEach(key => {
  database.register(initialModules[key].model, initialModules[key].store)
})

const debug = true

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],
  strict: debug,
  state: {
    api: null,
    breadcrumbLinks: []
  },
  getters: {
    api: state => state.api === null ? new Api() : state.api,
    currentRoutePath: state => state.route.path,
    breadcrumbLinks: state => state.breadcrumbLinks
  },
  actions: {
    reset () {
      Object.keys(initialModules).forEach(key => {
        if (this._mutations[`entities/${key}/reset`]) {
          this.commit(`entities/${key}/reset`,
            Object.keys(initialModules[key].initalState)
              .reduce(function (accumulateur, stateKey) {
                if (typeof initialModules[key].initalState[stateKey] === 'object' && initialModules[key].initalState[stateKey] !== null) {
                  accumulateur[stateKey] = { ...initialModules[key].initalState[stateKey] }
                } else {
                  accumulateur[stateKey] = initialModules[key].initalState[stateKey]
                }
                return accumulateur
              }, {})
          )
        }
      })
    }
  },
  modules: {
  },
  mutations: {
  }
})
